<template>
  <div class="app-container">
    <div>
      <AllServiceDataConfirmation :service-data="serviceConfirmationData" />
      <VLoader v-if="isLoading" />
      <router-view v-else />
      <EnvSelector />
    </div>
  </div>
</template>

<script setup>
import { inject } from "vue";
import { useRouter, useRoute } from "vue-router";
import EnvSelector from "~/components/EnvSelector";
import { injectHttpUIEffect } from "~/lib/httpUIEffect/index";

const router = useRouter();
const route = useRoute();
const { defaultPage } = inject("siteConfig").siteConfigData;

const { isLoading, serviceConfirmationData } = injectHttpUIEffect();

async function init() {
  if (route.path == "/") router.replace(defaultPage);
}

init();
</script>
